export const convertDataToReferenceTable = (data: any) => {
  const convertedReferenceTable = data.map((item: any) => {
    const title = `${item.range_from}-${item.range_to} characters`;
    const value = `${item.credit_value} credit`;

    return { title, value };
  });

  return convertedReferenceTable;
};

export const extractAfterTripleBraces = (value: string) => {
  const tripleBracesIndex = value.lastIndexOf('}}}');

  if (tripleBracesIndex !== -1) {
    return value.substring(tripleBracesIndex + 3).trim();
  } else {
    return value;
  }
};
